import  {createApp } from 'vue'
import AppWrapper from './AppWrapper.vue'
import router from './router'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import MapDialog from './components/MapDialog'
import Pagination from './components/Pagination'
//import { clearAllStorage } from '@/utils/auth'
import CarNumber from 'car-number-vue3-onchange'
import 'car-number-vue3-onchange/lib/carNumber.css'
import LicensePlate from 'vue3-license-plate'
import 'vue3-license-plate/lib/licensePlate.css'
import locale from "element-plus/es/locale/lang/zh-cn";

// Clear any existing tokens on app startup (for testing)
if (process.env.NODE_ENV === 'development') {
  console.log('Development mode - clearing any stored auth tokens');
  // clearAllStorage();
}


const app = createApp(AppWrapper)



// Register all icons
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}



app.config.ignoredElements = ['wx-open-launch-weapp']
app.use(ElementPlus, { locale })
app.use(router)
app.use(CarNumber)
app.use(LicensePlate)
app.component(MapDialog.name, MapDialog)
app.component('CustomPagination', Pagination)
app.mount('#app')



